import { DefaultThemeValueType } from "../../../../styled";

export enum ButtonCategory {
  diam = "diam",
  gem = "gem",
  jewelry = "jewelry",
  lab = "lab",
  default = "default",
}

export enum ButtonType {
  primary,
  secondary,
  tertiary,
}

export type ButtonProps = {
  title: string | boolean;
  category: ButtonCategory;
  type?: ButtonType;
  disabled?: boolean;
  loading?: boolean;
  onPress?: () => void;
  testID?: string;
  dataTestId?: string;
  showIcon?: boolean;
  iconSource?: string;
  height?: number;
  width?: number;
  borderRadius?: number;
  iconColor?: string;
  iconSize?: number;
  paddingLeftText?: number;
  textTypographyStyle?: string;
  hideText?: boolean;
  showLeftText?: boolean;
  manualColor?: string;
  isDisableInteraction?: boolean;
  alignIconInLeft?: boolean;
  maxWidth?: number;
  solidBackground?: boolean;
  /** Theme token for gradient/solid background (e.g. theme key or "linear-gradient(...)"). When set, uses ThemedBackground; otherwise uses category/type solid styles. */
  token?: string;
};

export type ButtonCategoryStyle = {
  textColor: DefaultThemeValueType;
  background: DefaultThemeValueType;
  borderColor: DefaultThemeValueType;
  hover: DefaultThemeValueType;
};

export type SelectedItemTheme = {
  primary: DefaultThemeValueType;
  secondary: DefaultThemeValueType;
  one: DefaultThemeValueType;
  three: DefaultThemeValueType;
};

export type IconCategoryStyle = {
  textColor: DefaultThemeValueType;
};
